/* SELVA, kurven. Adfærden ligger her i stedet for i sections/selva-kurv.liquid. Alt sektionen skal give videre, står som data-attributter og JSON på rodelementet.
   16. okt 2026: besparelsen regnes også af variantens før-pris (compare_at_price), så pakker og tilbud viser hele besparelsen.
   22. okt 2026 (kladde 1p): fri fragt-bjælken og en ren tilbudstimer ligger i toppen. Bunden viser I alt med prisen uden nogen rabat overstreget. Upsell er en vandret scroll (op til 6 kort) i den rækkefølge, sektionsindstillingen upsell_handles giver.
   Timeren viser kun en RIGTIG tilbudsfrist (sektionsindstillingen timer_slut), aldrig en opfundet reservation eller nedtælling: varerne er ikke reserveret.
   PAKKE-koder fra "Byg din pakke" fjernes automatisk, når kurven har et Halloween-tilbud (de må ikke stables). */
(function () {
  if (/\/cart\/?$/.test(location.pathname)) {
    var tilbage = '/';
    try {
      var u = new URL(document.referrer);
      if (u.origin === location.origin && !/\/(cart|checkouts?)(\/|$)/.test(u.pathname)) tilbage = u.pathname + u.search;
    } catch (err) {}
    try { sessionStorage.setItem('skvAabn', '1'); } catch (err) {}
    location.replace(tilbage);
    return;
  }

  var rod = document.querySelector('[data-skv]');
  if (!rod || rod.dataset.skvInit) return;
  rod.dataset.skvInit = 'true';

  var data = JSON.parse(rod.querySelector('[data-skv-data]').textContent);
  if (data.friFragtGraense > 0 && window.selvaKurs && window.selvaValuta && window.selvaValuta !== 'DKK') {
    data.friFragtGraense = Math.ceil(data.friFragtGraense / 100 * window.selvaKurs()) * 100;
  }
  var linjerEl = rod.querySelector('[data-skv-linjer]');
  var tomEl = rod.querySelector('[data-skv-tom]');
  var bundEl = rod.querySelector('[data-skv-bund]');
  var infoEl = rod.querySelector('[data-skv-info]');
  var ialtEl = rod.querySelector('[data-skv-ialt]');
  var ialtFoerEl = rod.querySelector('[data-skv-ialt-foer]');
  var antalEl = rod.querySelector('[data-skv-antal]');
  var fragtEl = rod.querySelector('[data-skv-fragtbar]');
  var fragtTekst = rod.querySelector('[data-skv-fragt-tekst]');
  var fragtFyld = rod.querySelector('[data-skv-fragt-fyld]');
  var fragtNoteEl = rod.querySelector('[data-skv-fragtnote]');
  var timerEl = rod.querySelector('[data-skv-timer]');
  var timerTekst = rod.querySelector('[data-skv-timer-tekst]');
  var upsellEl = rod.querySelector('[data-skv-upsell]');
  var sporEl = rod.querySelector('[data-skv-spor]');
  var arbejder = false;
  var kurvIndhold = false;

  var ABO_FRI = 27900; /* abonnement med mindst 279 kr i kurven har fri fragt (automatisk Shopify-rabat), kun DK, samme regel som assets/custom.js */
  var GAVE_PRODUKTER = ['horse-bristle-toothbrush-4-pak'];
  var GAVE_TEKST = 'Gratis tungeskraber i din næste levering';
  var UPSELL_MAX = 6;
  /* Pakker der allerede indeholder tilbehøret: så skjules upsell-rækken, så kurven ikke foreslår det kunden lige har købt. */
  var PAKKER_UDEN_UPSELL = ['halloween-hele-munden-plastfri', 'halloween-tilbehorspakke', 'black-month-hele-munden', 'black-month-tilbehorspakke', 'black-friday-el-hele-rutinen', 'black-friday-12-pak-hele-rutinen'];

  /* Før-priser pr. variant (øre). /cart.js giver dem ikke, så de hentes fra /products/<handle>.js og gemmes. */
  var VAERDI = {};
  try { VAERDI = JSON.parse(sessionStorage.getItem('skvVaerdi2') || '{}') || {}; } catch (err) { VAERDI = {}; }

  function kr(oere) {
    if (window.selvaPenge) return window.selvaPenge(oere);
    return (Math.round(oere) / 100).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr.';
  }
  function tekst(v) {
    var d = document.createElement('div');
    d.textContent = v == null ? '' : String(v);
    return d.innerHTML;
  }
  function nul(n) { return n < 10 ? '0' + n : String(n); }

  var TILBUD_RE = /^(halloween|black-month|black-week|black-friday)-/;
  function erHalloween(vare) {
    return TILBUD_RE.test(vare.handle || '') || !!(vare.properties && vare.properties['Tilbud']);
  }
  function tilbudNavn(kurv) {
    var m = null;
    (kurv.items || []).some(function (v) { m = TILBUD_RE.exec(v.handle || ''); return !!m; });
    var p = m ? m[1] : '';
    if (p === 'halloween') return 'Halloween';
    if (p === 'black-month') return 'Black Month';
    if (p === 'black-week') return 'Black Week';
    if (p === 'black-friday') return window.selvaPeriodeNavn === 'Cyber Monday' ? 'Cyber Monday' : 'Black Friday';
    return window.selvaPeriodeNavn || 'Halloween';
  }
  function harHalloween(kurv) {
    return (kurv.items || []).some(erHalloween);
  }
  function erDK(kurv) {
    if (kurv.currency && kurv.currency !== 'DKK') return false;
    if (window.Shopify && Shopify.country && Shopify.country !== 'DK') return false;
    return true;
  }

  /* Tilbudsfristen kommer enten fra sektionsindstillingen timer_slut (manuel) eller fra Black-periodens rigtige slutdato (selva-black: window.selvaPeriode().slut).
     Periodefristen vises kun, når kurven rummer en tilbudspakke (ikke ved almindelige varer) og aldrig før Black Month starter. */
  var manuelSlut = data.timerSlut ? Date.parse(data.timerSlut) : NaN;
  (function () { var st = document.createElement('style'); st.textContent = '.har-gave1 [data-skv-fordele]{display:none!important}' +
    /* 31.10: Black-upsell i kurven lys i stedet for næsten sort; stjerner gule #F4B400 som på produktsiderne (Sylvester 1.11: "ingen grønne stjerner i kurven") */
    '.skv__stjerner path{fill:#F4B400}' +
    '.sbk-po--kurv .sbk-po__in{background:#F3ECE4;color:#1D2E1F}' +
    '.sbk-po--kurv .sbk-po__img{background:#fff}' +
    '.sbk-po--kurv .sbk-po__navn{color:#6B4A36}' +
    '.sbk-po--kurv .sbk-po__t,.sbk-po--kurv .sbk-po__p b{color:#1D2E1F}' +
    '.sbk-po--kurv .sbk-po__p s{color:#8A8178}' +
    '.sbk-po--kurv .sbk-po__s{background:#EAF0E4;color:#1D2E1F}' +
    '.sbk-po--kurv .sbk-po__btn{background:#1D2E1F;color:#fff}' +
    '.sbk-po--kurv .sbk-po__ho{border-color:#D9CFC2;color:#1D2E1F;background:#fff}' +
    '.sbk-po--kurv .sbk-po__ho.on{border-color:#1D2E1F;box-shadow:inset 0 0 0 1px #1D2E1F}' +
    /* 31.10 (TASKS #87): ét tilkøbskort i stedet for rækken */
    '.skv__tk{display:flex;align-items:center;gap:14px;padding:12px;border:1px solid #E9E4DC;border-radius:14px;background:#fff}' +
    '.skv__tk img{width:76px;height:76px;flex:0 0 76px;object-fit:cover;border-radius:10px;background:#F2EDE6}' +
    '.skv__tk-tekst{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:3px}' +
    '.skv__tk-navn{font-size:15px;font-weight:500;color:#1D2E1F;text-decoration:none;line-height:1.3}' +
    '.skv__tk-linje{font-size:13px;color:#6F6A62;line-height:1.4}' +
    '.skv__tk-pris{font-size:15px;font-weight:600;color:#1D2E1F}' +
    '.skv__tk-pris s{margin-left:6px;font-weight:400;color:#8A8178}' +
    '.skv__spor.er-tk{display:block!important;overflow:visible!important;padding:0 18px 0 0!important;mask-image:none!important;-webkit-mask-image:none!important}.skv__spor.er-tk::after,.skv__spor.er-tk::before{display:none!important}' +
    '.skv__tk-spar{display:inline-block;margin-left:8px;padding:2px 8px;border-radius:999px;background:#EAF0E4;color:#1D2E1F;font-size:12px;font-weight:600;font-style:normal;vertical-align:1px}' +
    '.skv__tk-pris s{margin-left:6px}' +
    '.skv__tk-knap{text-decoration:none;display:inline-flex;align-items:center;flex:0 0 auto;height:40px;padding:0 18px;border:0;border-radius:999px;background:#1D2E1F;color:#F9F6F2;font-size:14px;font-weight:500;cursor:pointer}'; document.head.appendChild(st); })();
  var tilbudIKurv = false;
  /* 31.10: abo-gaven i 1. levering gælder til og med 1. december; vises når kurven har en vare med linjeegenskaben "Gave i 1. levering" eller "Gave" */
  var GAVE_SLUT = Date.parse('2026-12-01T23:59:59+01:00');
  var gaveIKurv = false;
  function timerSlutNu() {
    if (!isNaN(manuelSlut)) return { ms: manuelSlut, kraever: false };
    try {
      var p = window.selvaPeriode && window.selvaPeriode();
      if (p && !p.foer && p.slut) return { ms: p.slut, kraever: true };
    } catch (e) {}
    return { ms: NaN, kraever: false };
  }
  function tik() {
    if (!timerEl) return;
    var f = timerSlutNu();
    var d = f.ms - Date.now();
    var gave = false;
    if ((isNaN(f.ms) || (f.kraever && !tilbudIKurv)) && gaveIKurv && Date.now() >= Date.parse('2026-11-01T00:00:00+01:00')) { f = { ms: GAVE_SLUT, kraever: false }; d = f.ms - Date.now(); gave = true; }
    if (isNaN(f.ms) || d <= 0 || !kurvIndhold || (f.kraever && !tilbudIKurv)) { timerEl.hidden = true; return; }
    var dage = Math.floor(d / 864e5), t = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
    var tid = dage > 0 ? dage + 'd ' + t + 't ' + m + 'm' : nul(t) + ':' + nul(m) + ':' + nul(s);
    timerTekst.innerHTML = tekst(gave ? 'Gaven i første pakke følger kun med i [tid] endnu' : (data.timerTekst || 'Tilbuddet slutter om [tid]')).replace('[tid]', '<strong>' + tid + '</strong>');
    timerEl.hidden = false;
  }
  setInterval(tik, 1000);

  function sikrVaerdi(kurv) {
    var mangler = {};
    (kurv.items || []).forEach(function (v) {
      if (!(String(v.variant_id) in VAERDI) && v.handle) mangler[v.handle] = true;
    });
    var handles = Object.keys(mangler);
    if (!handles.length) return Promise.resolve(kurv);
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          p.variants.forEach(function (pv) { VAERDI[String(pv.id)] = pv.compare_at_price || 0; });
        })
        .catch(function () {});
    })).then(function () {
      try { sessionStorage.setItem('skvVaerdi2', JSON.stringify(VAERDI)); } catch (err) {}
      return kurv;
    });
  }

  /* PAKKE5/8/10/15 (fra "Byg din pakke") må ikke ligge oven i et Halloween-tilbud. */
  function rydPakkekoder(kurv) {
    if (!harHalloween(kurv)) return Promise.resolve(kurv);
    var koder = [];
    (kurv.cart_level_discount_applications || []).forEach(function (d) { if (d.type === 'discount_code') koder.push(d.title || ''); });
    (kurv.items || []).forEach(function (v) {
      (v.line_level_discount_allocations || []).forEach(function (a) {
        var d = a.discount_application || {};
        if (d.type === 'discount_code') koder.push(d.title || '');
      });
    });
    if (!koder.some(function (k) { return /^PAKKE/i.test(k); })) return Promise.resolve(kurv);
    var behold = koder.filter(function (k, i) { return k && !/^PAKKE/i.test(k) && koder.indexOf(k) === i; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: behold.join(',') })
    })
      .then(function () { return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .catch(function () { return kurv; });
  }

  function sammenlign(vare) {
    var s = vare.original_price || 0;
    /* 18.10 Black: én førpris. Variantens compare_at bruges kun på Black-pakkerne; ellers er førprisen engangsprisen */
    var ca = (vare.handle || '').indexOf('black-') === 0 ? (VAERDI[String(vare.variant_id)] || 0) : 0;
    if (ca > s) s = ca;
    if (vare.selling_plan_allocation && vare.selling_plan_allocation.compare_at_price > s) {
      s = vare.selling_plan_allocation.compare_at_price;
    }
    if (s < vare.final_price) s = vare.final_price;
    return s;
  }

  /* 1.11 (Sylvester: "kurven kommer hele tiden frem"): kurvens egne gave-kald (abo-gave, Cyber Monday-gave) går uden om lytteren nedenfor,
     så kurven ikke åbner af sig selv ved et sideskift, bare fordi gaven bliver lagt i. */
  function stille(url, opts) { return (origFetch || fetch).call(window, url, opts); }

  function aabn() {
    rod.hidden = false;
    void rod.offsetWidth;
    rod.classList.add('er-aaben');
    document.documentElement.style.overflow = 'hidden';
  }
  function luk() {
    rod.classList.remove('er-aaben');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!rod.classList.contains('er-aaben')) rod.hidden = true; }, 340);
  }

  function tegn(kurv) {
    var antal = kurv.item_count || 0;
    kurvIndhold = antal > 0;
    tilbudIKurv = harHalloween(kurv);
    gaveIKurv = (kurv.items || []).some(function (v) { return v.properties && (v.properties['Gave i 1. levering'] || v.properties['Gave']); });
    /* 31.10 Black: abo-gaven i 1. levering. Erstatter custom.js' boks ("levering 2 og 4") når en abo-linje har egenskaben */
    var gave1 = [];
    (kurv.items || []).forEach(function (v) {
      var g = v.selling_plan_allocation && v.properties && (v.properties['Gave i 1. levering'] || v.properties['Gave']);
      if (g && gave1.indexOf(g) === -1) gave1.push(g);
    });
    rod.classList.toggle('har-gave1', gave1.length > 0);
    var talEl = rod.querySelector('.skv__tal'), g1Boks = rod.querySelector('[data-skv-gave1]');
    if (gave1.length && talEl) {
      if (!g1Boks) { g1Boks = document.createElement('div'); g1Boks.className = 'skv__fordele'; g1Boks.setAttribute('data-skv-gave1', ''); talEl.parentNode.insertBefore(g1Boks, talEl); }
      var CHK = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M4 12.5l5.2 5.2L20 7'></path></svg>";
      g1Boks.innerHTML = '<p class="skv__fordele-titel">Med abonnement får du</p><ul><li>' + CHK + 'Gratis fragt</li>' +
        gave1.map(function (g) { return '<li>' + CHK + 'Gratis i første pakke: ' + tekst(g) + '</li>'; }).join('') + '</ul>';
      g1Boks.hidden = false;
    } else if (g1Boks) { g1Boks.hidden = true; }
    antalEl.textContent = antal ? '(' + antal + ')' : '';
    tomEl.hidden = antal > 0;
    bundEl.hidden = antal === 0;
    if (infoEl) infoEl.hidden = antal === 0;
    linjerEl.innerHTML = '';
    var harAbo = false;

    kurv.items.forEach(function (vare, i) {
      var abo = vare.selling_plan_allocation && vare.selling_plan_allocation.selling_plan
        ? vare.selling_plan_allocation.selling_plan.name : '';
      abo = abo.replace(/\s*[—–]\s*/g, ', ');
      var harGave = GAVE_PRODUKTER.indexOf(vare.handle) !== -1;
      if (abo) harAbo = true;
      var egen = vare.properties ? Object.keys(vare.properties).filter(function (k) {
        return k.charAt(0) !== '_' && vare.properties[k];
      }).map(function (k) { return vare.properties[k]; }).join(' · ') : '';
      if (!egen && TILBUD_RE.test(vare.handle || '')) { var tn = tilbudNavn({ items: [vare] }); egen = (tn === 'Halloween' ? '🎃 ' : '✦ ') + tn + '-tilbud'; }
      var variant = vare.variant_title && vare.variant_title !== 'Default Title' ? vare.variant_title : '';
      var linjeFoer = sammenlign(vare) * vare.quantity;
      var foer = linjeFoer > vare.final_line_price ? '<s>' + kr(linjeFoer) + '</s>' : '';
      var billede = vare.image ? vare.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var rk = document.createElement('div');
      rk.className = 'skv__linje';
      rk.innerHTML =
        (billede ? `<img class='skv__billede' src='${billede}' alt='' loading='lazy' width='76' height='76'>` : `<span class='skv__billede'></span>`) +
        '<div>' +
          `<a class='skv__navn' href='${vare.url}'>${tekst(vare.product_title)}</a>` +
          (variant ? `<span class='skv__meta'>${tekst(variant)}</span>` : '') +
          (abo ? `<span class='skv__abo'>${tekst(abo)}</span>` : '') +
          (egen ? `<span class='skv__egen'>${tekst(egen)}</span>` : '') +
          (abo && harGave ? `<span class='skv__gave'>${tekst(GAVE_TEKST)}</span>` : '') +
          `<span class='skv__antal-boks'>` +
            `<button type='button' class='skv__antal-knap' data-skv-saet='${i + 1}' data-skv-nyt='${vare.quantity - 1}' aria-label='Færre'>&minus;</button>` +
            `<span class='skv__antal-tal'>${vare.quantity}</span>` +
            `<button type='button' class='skv__antal-knap' data-skv-saet='${i + 1}' data-skv-nyt='${vare.quantity + 1}' aria-label='Flere'>+</button>` +
          `</span>` +
        '</div>' +
        `<div class='skv__hoejre'>` +
          `<span class='skv__pris'>${foer}${kr(vare.final_line_price)}</span>` +
          `<button type='button' class='skv__fjern' data-skv-saet='${i + 1}' data-skv-nyt='0'>Fjern</button>` +
        `</div>`;
      linjerEl.appendChild(rk);
    });

    var foerRabat = 0;
    kurv.items.forEach(function (vare) { foerRabat += sammenlign(vare) * vare.quantity; });

    var trigger = document.querySelector('#cart-icon-bubble, .wt-cart__trigger');
    if (trigger) {
      var badge = trigger.querySelector('[data-skv-badge]');
      if (!badge) {
        badge = document.createElement('span');
        badge.setAttribute('data-skv-badge', '');
        trigger.appendChild(badge);
      }
      badge.textContent = antal > 0 ? String(antal) : '';
      badge.hidden = antal === 0;
    }

    var graense = data.friFragtGraense;
    if (harAbo && erDK(kurv)) graense = ABO_FRI;
    var harFriFragt = graense > 0 && (kurv.total_price || 0) >= graense;
    var mangler = graense > 0 ? graense - (kurv.total_price || 0) : 0;
    if (fragtEl && graense > 0) {
      if (mangler > 0) {
        fragtEl.classList.remove('er-opnaaet');
        var skabelon = data.fragtTekstMangler || 'Du mangler [belob] for fri fragt';
        fragtTekst.innerHTML = tekst(skabelon).replace('[belob]', '<strong>' + kr(mangler) + '</strong>');
        fragtFyld.style.width = Math.min(100, (kurv.total_price / graense) * 100) + '%';
      } else {
        fragtEl.classList.add('er-opnaaet');
        fragtTekst.innerHTML = '<strong>' + tekst(data.fragtTekstOpnaaet || 'Du har opnået fri fragt') + '</strong>';
        fragtFyld.style.width = '100%';
      }
    }

    /* I alt: prisen uden nogen rabat overstreget, så man ser hvad det kunne have kostet. */
    var sparet = foerRabat - (kurv.total_price || 0);
    if (ialtEl) ialtEl.textContent = kr(kurv.total_price);
    if (ialtFoerEl) {
      ialtFoerEl.textContent = sparet > 0 ? kr(foerRabat) : '';
      ialtFoerEl.hidden = !(sparet > 0);
    }
    if (fragtNoteEl) fragtNoteEl.hidden = harFriFragt;

    tik();
    tegnUpsell(kurv);
  }

  function tegnUpsell(kurv) {
    if (!sporEl) return;
    var iKurven = {};
    var skjul = false;
    kurv.items.forEach(function (v) {
      iKurven[v.product_id] = true;
      if (PAKKER_UDEN_UPSELL.indexOf(v.handle) !== -1 || /^black-/.test(v.handle || '')) skjul = true;
    });
    /* 31.10: Black-pakker (med "per") vises kun i deres periode, højst 2, forrest i rækken */
    var pr = window.selvaPeriode && window.selvaPeriode(), pk = pr && !pr.foer ? ((pr.key === 'cm' || pr.key === 'sc') ? 'bf' : pr.key) : '', nB = 0;
    var liste = data.upsell.filter(function (p) {
      if (iKurven[p.produktId]) return false;
      if (!p.per) return true;
      if (!pk || p.per.split(' ').indexOf(pk) < 0 || nB >= 2) return false;
      nB++; return true;
    }).slice(0, UPSELL_MAX);
    upsellEl.hidden = skjul || liste.length === 0 || kurv.item_count === 0;
    sporEl.innerHTML = '';
    if (labelEl && labelOrig !== null) labelEl.textContent = labelOrig;
    sporEl.classList.remove('er-tk');
    if (upsellEl.hidden) return;
    if (tegnBlack(kurv, pk, pr)) return;
    liste.forEach(function (p) {
      var kort = document.createElement('div');
      kort.className = 'skv__kort';
      var foer = p.foer > p.pris ? '<s>' + p.foerFormateret + '</s>' : '';
      var knap = p.kraeverValg
        ? `<a class='skv__kort-knap' href='${p.url}'>Vælg</a>`
        : `<button type='button' class='skv__kort-knap' data-skv-tilfoej='${p.id}'>Tilføj</button>`;
      kort.innerHTML =
        (p.billede ? `<img src='${p.billede}' alt='' loading='lazy'>` : '') +
        `<a class='skv__kort-navn' href='${p.url}'>${tekst(p.titel)}</a>` +
        `<span class='skv__kort-pris'>${foer}${p.prisFormateret}</span>` +
        knap;
      sporEl.appendChild(kort);
    });
    sporEl.scrollLeft = 0;
    sporSlut();
  }
  /* 1.11 (Sylvester: "tungeskraber til 99 kr er ikke det bedste move … upsell nogle Black Month-pakker"): 99 kr-kortet og dets rabat er fjernet.
     I Black-perioderne viser kurven i stedet ÉT kort med periodens pakke: tandbørste/el i kurven → pakken med tilbehør, ellers pakken med
     hele munden/12 børster. Ligger der allerede en Black-pakke i kurven, eller er pakkerne ikke tændt endnu, vises den almindelige række. */
  var labelEl = upsellEl ? upsellEl.querySelector('.skv__label') : null, labelOrig = labelEl ? labelEl.textContent : null;
  var BORSTE_ELLER_EL = [16212696465757, 16327303364957, 16494016627037, 16494465220957]; /* 4-pak, børn, el, el-hoveder */
  function tegnBlack(kurv, pk, pr) {
    if (!pk) return false;
    var pakker = data.upsell.filter(function (x) { return x.per && x.per.split(' ').indexOf(pk) > -1; });
    if (!pakker.length) return false;
    var iKurv = {}, harBorste = false;
    kurv.items.forEach(function (v) { iKurv[v.product_id] = true; if (BORSTE_ELLER_EL.indexOf(v.product_id) > -1) harBorste = true; });
    pakker = pakker.filter(function (x) { return !iKurv[x.produktId]; });
    if (!pakker.length) return false;
    var vaelg = function (re) { return pakker.filter(function (x) { return re.test(x.url); })[0]; };
    var u = (harBorste ? vaelg(/tilbehor/) : vaelg(/hele-munden|12-pak/)) || pakker[0];
    var spar = u.foer > u.pris ? Math.round((u.foer - u.pris) / 100) : 0;
    if (labelEl) labelEl.textContent = ((pr && pr.navn) || 'Black Month') + '-tilbud';
    sporEl.classList.add('er-tk');
    sporEl.innerHTML = "<div class='skv__tk'>" +
      (u.billede ? "<img src='" + u.billede + "' alt=''>" : '') +
      "<div class='skv__tk-tekst'><a class='skv__tk-navn' href='" + u.url + "'>" + tekst(u.titel) + "</a>" +
      (u.kort ? "<span class='skv__tk-linje'>" + tekst(u.kort) + "</span>" : '') +
      "<span class='skv__tk-pris'>" + u.prisFormateret + (u.foer > u.pris ? "<s>" + u.foerFormateret + "</s>" : '') +
      (spar ? "<em class='skv__tk-spar'>Spar " + spar.toLocaleString('da-DK') + " kr</em>" : '') + "</span></div>" +
      (u.kraeverValg ? "<a class='skv__tk-knap' href='" + u.url + "'>Vælg</a>" : "<button type='button' class='skv__tk-knap' data-skv-tilfoej='" + u.id + "'>Tilføj</button>") + "</div>";
    return true;
  }
  /* Fade i højre kant, så man kan se der er mere; væk når scrollen er i bund eller alt er synligt. */
  function sporSlut() {
    if (!sporEl) return;
    sporEl.classList.toggle('er-slut', sporEl.scrollLeft + sporEl.clientWidth >= sporEl.scrollWidth - 4);
  }
  if (sporEl) sporEl.addEventListener('scroll', sporSlut, { passive: true });

  function hent(aabnEfter) {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(rydPakkekoder)
      .then(sikrVaerdi)
      .then(cmGave)
      .then(aboGave)
      .then(function (kurv) { tegn(kurv); if (aabnEfter) aabn(); return kurv; });
  }

  /* 31.10 Abo-gaver i 1. levering (1.11-1.12): abonnement på 8/12 stk. giver en tungeskraber, 4/12 stk. giver tandtråd.
     Kurven lægger gaven i med egenskaben "Gave: 1. levering"; rabatterne "Abo-gave 1.11-1.12" gør den gratis. */
  var AG_FRA = Date.parse('2026-11-01T00:00:00+01:00'), AG_TIL = Date.parse('2026-12-01T23:59:59+01:00'), agTravl = false;
  var AG_SKRABER = 65314501296477, AG_TRAAD = 65791680217437;
  var AG_8_12 = [65874092654941, 65874092687709, 65917541515613, 65917541548381, 65925411209565, 65925411242333];
  var AG_4_12 = [64757154971997, 65917541482845, 65874092687709, 65917541548381, 65925411242333];
  function aboGave(kurv) {
    if (agTravl || !kurv || !kurv.items) return kurv;
    var p = window.selvaPeriode && window.selvaPeriode(), nu = Date.now();
    var aktiv = (nu >= AG_FRA && nu <= AG_TIL) || !!(p && p.preview);
    var vilSkraber = false, vilTraad = false, harSkraber = null, harTraad = null;
    kurv.items.forEach(function (i) {
      var gave = i.properties && i.properties.Gave === '1. levering';
      if (gave && i.variant_id === AG_SKRABER) harSkraber = i;
      else if (gave && i.variant_id === AG_TRAAD) harTraad = i;
      else if (i.selling_plan_allocation) {
        if (AG_8_12.indexOf(i.variant_id) > -1) vilSkraber = true;
        if (AG_4_12.indexOf(i.variant_id) > -1) vilTraad = true;
      }
    });
    vilSkraber = vilSkraber && aktiv; vilTraad = vilTraad && aktiv;
    var tilfoej = [], aendr = [];
    if (vilSkraber && !harSkraber) tilfoej.push({ id: AG_SKRABER, quantity: 1, properties: { Gave: '1. levering' } });
    if (vilTraad && !harTraad) tilfoej.push({ id: AG_TRAAD, quantity: 1, properties: { Gave: '1. levering' } });
    if (harSkraber && (!vilSkraber || harSkraber.quantity !== 1)) aendr.push({ id: harSkraber.key, quantity: vilSkraber ? 1 : 0 });
    if (harTraad && (!vilTraad || harTraad.quantity !== 1)) aendr.push({ id: harTraad.key, quantity: vilTraad ? 1 : 0 });
    if (!tilfoej.length && !aendr.length) return kurv;
    agTravl = true;
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var kaede = Promise.resolve();
    aendr.forEach(function (a) { kaede = kaede.then(function () { return fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify(a) }); }); });
    if (tilfoej.length) kaede = kaede.then(function () { return stille('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: tilfoej }) }); });
    return kaede.then(function () { return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (k) { agTravl = false; return k; }, function () { agTravl = false; return kurv; });
  }

  /* 31.10 Cyber Monday-gave (30.11-1.12): ved mindst 799 kr i kurven lægges 1 tungeskraber i som gave; Shopify-rabatten
     "Cyber Monday: gratis tungeskraber over 799 kr" gør den gratis. Falder kurven under 799 kr, fjernes gaven igen. */
  var CM_VARIANT = 65314501296477, CM_FRA = Date.parse('2026-11-30T00:00:00+01:00'), CM_TIL = Date.parse('2026-12-01T23:59:59+01:00'), cmTravl = false;
  function cmGave(kurv) {
    if (cmTravl || !kurv || !kurv.items) return kurv;
    var p = window.selvaPeriode && window.selvaPeriode(), nu = Date.now();
    var aktiv = (nu >= CM_FRA && nu <= CM_TIL) || !!(p && p.preview && (p.key === 'cm' || p.key === 'sc'));
    var gave = null, sum = 0;
    kurv.items.forEach(function (i) {
      if (i.variant_id === CM_VARIANT && i.properties && i.properties.Gave) gave = i; else sum += i.final_line_price;
    });
    var skal = aktiv && sum >= 79900, kald = null;
    if (skal && !gave) kald = stille('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: CM_VARIANT, quantity: 1, properties: { Gave: 'Cyber Monday' } }] }) });
    else if (gave && (!skal || gave.quantity !== 1)) kald = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: gave.key, quantity: skal ? 1 : 0 }) });
    if (!kald) return kurv;
    cmTravl = true;
    return kald.then(function () { return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (k) { cmTravl = false; return k; }, function () { cmTravl = false; return kurv; });
  }

  function laeg(krop) {
    if (arbejder) return Promise.resolve();
    arbejder = true;
    /* 31.10: er en Black-pakke ikke aktiv endnu (422), lægges den almindelige vare i kurven i stedet, så "Forudbestil" aldrig fejler */
    var RESERVE = { 66216531460445: 65790411866461 };
    function send(k) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(k)
      });
    }
    return send(krop)
      .then(function (r) {
        if (r.status !== 422 || !krop.items || !krop.items.some(function (v) { return RESERVE[v.id]; })) return r;
        var ny = { items: krop.items.map(function (v) {
          if (!RESERVE[v.id]) return v;
          var p = {}; Object.keys(v.properties || {}).forEach(function (n) { if (n !== 'Tilbud') p[n] = v.properties[n]; });
          return { id: RESERVE[v.id], quantity: v.quantity || 1, properties: p };
        }) };
        return send(ny);
      })
      .then(function () { return hent(true); })
      .catch(function () { window.location = '/cart'; })
      .then(function () { arbejder = false; });
  }

  function saet(linje, antal) {
    if (arbejder) return;
    arbejder = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linje, quantity: antal })
    })
      .then(function (r) { return r.json(); })
      .then(rydPakkekoder)
      .then(sikrVaerdi)
      .then(cmGave)
      .then(aboGave)
      .then(tegn)
      .catch(function () {})
      .then(function () { arbejder = false; });
  }

  var origFetch = window.fetch;
  if (origFetch && !window.__skvWrap) {
    window.__skvWrap = true;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !window.__skvEgen && !arbejder) {
        p.then(function (r) { if (r && r.ok) setTimeout(function () { hent(true); }, 60); }).catch(function () {});
      }
      return p;
    };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var felter = new FormData(form);
    var krop = { items: [{ id: Number(felter.get('id')), quantity: Number(felter.get('quantity') || 1) }] };
    var plan = felter.get('selling_plan');
    if (plan) krop.items[0].selling_plan = Number(plan);
    var egenskaber = {};
    felter.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && typeof v === 'string' && v !== '') egenskaber[m[1]] = v;
    });
    if (Object.keys(egenskaber).length) krop.items[0].properties = egenskaber;
    /* 31.10: ekstra varer fra formularen (fx hoved-abo på el 799): ekstra[N][id], [quantity], [selling_plan] */
    var ekstra = {};
    felter.forEach(function (v, k) {
      var m = /^ekstra\[(\d+)\]\[(id|quantity|selling_plan)\]$/.exec(k);
      if (m && v !== '') { (ekstra[m[1]] = ekstra[m[1]] || {})[m[2]] = Number(v); }
    });
    Object.keys(ekstra).sort().forEach(function (n) {
      var x = ekstra[n]; if (!x.id) return;
      var it = { id: x.id, quantity: x.quantity || 1 }; if (x.selling_plan) it.selling_plan = x.selling_plan;
      krop.items.push(it);
    });
    laeg(krop);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('#cart-icon-bubble, .wt-cart__trigger, a[href="/cart"], a[href$="/cart"]');
    if (!a || a.hasAttribute('data-skv-betal')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    hent(true);
  }, true);

  rod.addEventListener('click', function (e) {
    var m = e.target.closest ? e.target.closest('[data-skv-luk]') : null;
    if (m) { luk(); return; }
    var t = e.target.closest ? e.target.closest('[data-skv-tilfoej]') : null;
    if (t) { laeg({ items: [{ id: Number(t.getAttribute('data-skv-tilfoej')), quantity: 1 }] }); return; }
    var q = e.target.closest ? e.target.closest('[data-skv-saet]') : null;
    if (q) { saet(Number(q.getAttribute('data-skv-saet')), Number(q.getAttribute('data-skv-nyt'))); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && rod.classList.contains('er-aaben')) luk();
  });

  window.selvaKurv = { aabn: function () { hent(true); }, luk: luk, opdater: function () { return hent(false); } };

  var skalAabnes = false;
  try { skalAabnes = sessionStorage.getItem('skvAabn') === '1'; sessionStorage.removeItem('skvAabn'); } catch (err) {}
  hent(skalAabnes);
})();
